import { generateTypes } from '../../utils/HttpReducerHelper';

export const offersHistory = generateTypes('FUNDING_SEARCH', 'OFFERS_HISTORY');
